import React from 'react'
import siteUrl from '../../shared/utils/siteUrl'
import Layout from '../../shared/components/organisms/layout/layout'
import ContentSalesForm from '../organisms/content-sales-form/content-sales-form'

const TemplateSaleForm = props => {
    const { pageContext } = props
    const { slug } = pageContext

    const SEOconfig = {
        title: "Formulario " + pageContext.metaTitulo,
        slug:siteUrl + '/bienes-en-venta/' + slug,
        meta: [{
            name: 'robots',
            content: 'noindex, nofollow'
        }]
    }

    return (
        <Layout>
            <ContentSalesForm info={ pageContext } SEOconfig={SEOconfig}/>
        </Layout>
    )
}

export default TemplateSaleForm
